/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TermsAndConditionRequest = {
    properties: {
        title: {
    type: 'string',
    isRequired: true,
},
        description: {
    type: 'string',
    isRequired: true,
},
    },
};